import { useAccountApplicationQuery, useCreateAccountApplicationMutation, useUpdateAccountApplicationMutation, useDeleteAccountApplicationMutation } from './useAccountApplicationsQuery';
import { AccountApplication } from '../types';
import { useParams } from 'react-router-dom';

export const useAccountApplication = (applicationId?: string) => {

    const { id: accountId } = useParams();

    const { data: record, isLoading: loading, refetch: fetchRecord } = useAccountApplicationQuery(applicationId || '');
    const createAccountApplicationMutation = useCreateAccountApplicationMutation();
    const updateAccountApplicationMutation = useUpdateAccountApplicationMutation();
    const deleteAccountApplicationMutation = useDeleteAccountApplicationMutation();

    const createRecord = async (values: AccountApplication) => {
        if (accountId) {
            values.accountId = accountId;
        }
        return await createAccountApplicationMutation.mutateAsync(values);
    };

    const updateRecord = async (values: AccountApplication) => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await updateAccountApplicationMutation.mutateAsync({ id: applicationId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof applicationId === 'undefined') {
            throw new Error('applicationId is required parameter');
        }
        return await deleteAccountApplicationMutation.mutateAsync(applicationId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
